import React from 'react'

function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img src="/prata_logo.svg" alt="Prata" className="h-8 w-auto mr-3" />
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Transformamos ideias em realidade digital através de soluções tecnológicas inovadoras e personalizadas para o seu negócio.
            </p>
            <div className="text-sm text-gray-400">
              © 2025 Prata Consultoria em Tecnologia da Informação LTDA. Todos os direitos reservados.
              <br />
              CNPJ: 48.889.573/0001-44
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#2F5496]">Links Rápidos</h3>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors">Início</a></li>
              <li><a href="/about" className="text-gray-300 hover:text-white transition-colors">Sobre</a></li>
              <li><a href="/services" className="text-gray-300 hover:text-white transition-colors">Serviços</a></li>
              <li><a href="/contact" className="text-gray-300 hover:text-white transition-colors">Contato</a></li>
              <li><a href="/quote" className="text-gray-300 hover:text-white transition-colors">Solicitar Orçamento</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#2F5496]">Contato</h3>
            <div className="space-y-2 text-gray-300">
              <p>📧 ceo@prata.dev.br</p>
              <p>📱 (48) 98444-8798</p>
              <p>🏢 CNPJ: 48.889.573/0001-44</p>
              <p className="text-sm">
                Monte Cambirela, 228 - Sala 03<br />
                Praia de Fora<br />
                Palhoça - SC, 88138-700
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            Desenvolvido com ❤️ pela equipe Prata Consultoria
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
